/* eslint-disable no-case-declarations */
import { QueryClientConfig } from "@tanstack/react-query";
import { redirectToNoAccessPage } from "utils/eventSwitcher";

import openToast from "utils/openToast";

export const handleGlobalError = async (error: any) => {
  const status = error.statusCode || error.status;
  if (status) {
    switch (status) {
      case 401:
        // Handle unauthenticated access
        openToast(
          "Please check your internet connection and try again.",
          "error",
        );

        localStorage.clear();

        setTimeout(() => {
          window.location.href = "/";
        }, 2000);

        break;
      case 403:
        redirectToNoAccessPage();
        break;
      case 404:
        // Handle not found

        openToast(
          "We couldn't find the page or content you're looking for. Please check the URL or try again later.",
          "error",
        );
        redirectToNoAccessPage();
        break;
      case 422: {
        const errorData = await error.json();
        openToast(
          errorData?.error ||
            "Something went wrong with the request. Please try again.",
          "error",
        );

        break;
      }
      case 500:
        // Handle server error
        openToast("Something wrong happened, please contact support.", "error");
        break;
      default:
        openToast("An error occurred. Please try again.", "error");
    }
  } else {
    openToast(
      error.message || error.error || "An error occurred. Please try again.",
      "error",
    );
  }
};

export const queryClientOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: handleGlobalError,
      useErrorBoundary: true,
    },
    mutations: {
      onError: handleGlobalError,
      useErrorBoundary: false,
    },
  },
};
